import type { CalculatedMaterial } from "./types";

// A standalone glazing unit has no material frame, hinges or sash. Do not send
// it through the generic window renderer, which would invent those components.
export function StandaloneInfillDrawing({ widthMm, heightMm, materials, onSelect }: {
  widthMm: number; heightMm: number; materials: CalculatedMaterial[];
  onSelect: (material: CalculatedMaterial) => void;
}) {
  const glass = materials.find(material => material.category === "Infill");
  const scale = Math.min(260 / widthMm, 260 / heightMm);
  const w = widthMm * scale, h = heightMm * scale;
  const x = (360 - w) / 2, y = (320 - h) / 2;
  return <section aria-label="Эскиз отдельного стеклопакета">
    <p className="measure-accuracy">Отдельное заполнение без рамы и фурнитуры. Это размерная схема, не CAD-модель слоёв стеклопакета. Раскрой листов и отходы ещё не подтверждены.</p>
    <svg viewBox="0 0 400 350" style={{ width: "100%", maxHeight: 420 }} role="img" aria-label={`Стеклопакет ${widthMm} на ${heightMm} мм`}>
      <rect x={x} y={y} width={w} height={h} fill="#e4f3f7" stroke="#486c79" strokeWidth="2"
        role="button" tabIndex={0} aria-label={glass ? `${glass.code} · ${glass.name}` : "Заполнение"}
        onClick={() => glass && onSelect(glass)} onKeyDown={event => {
          if (glass && (event.key === "Enter" || event.key === " ")) { event.preventDefault(); onSelect(glass); }
        }} />
      <path d={`M${x},${y + h + 14}h${w} M${x},${y + h + 9}v10 M${x + w},${y + h + 9}v10`} fill="none" stroke="#486c79" />
      <text x={x + w / 2} y={y + h + 31} textAnchor="middle" fontSize="12">{widthMm} мм</text>
      <text x={x + w + 8} y={y + h / 2} fontSize="12">{heightMm} мм</text>
    </svg>
    {glass && <button type="button" className="secondary" onClick={() => onSelect(glass)}>{glass.code} · {glass.name}</button>}
  </section>;
}
